import CodeChip from "@components/code-chip";
import MediaAssetMetaUpdate from "../asset/MediaAssetMetaUpdate";
import { useState } from "react";

type pUpload = {
  id: string;
  videoCode: string;
  video_url: string;
  localText: string;
  translation: string;
  onVideoChange: (val: boolean) => void;
  IsVideoSelected: boolean;
};

function VideoCardComponent({
  id,
  video_url,
  videoCode,
  localText,
  translation,
  onVideoChange,
  IsVideoSelected,
}: pUpload) {
  const [isOpen, setClose] = useState<boolean>(false);

  const handlOpenEditingModal = (val: boolean) => {
    setClose(val);
  };

  return (
    <>
      <article className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden p-4 flex flex-col">
        <div className="mb-4">
          <CodeChip code={videoCode} />
        </div>

        <div className="aspect-video w-full rounded-md overflow-hidden mb-2">
          <video controls className="w-full h-full object-contain">
            <source src={video_url} type="video/mp4" />
          </video>
        </div>

        <div className="text-sm mb-2">
          <p className="font-medium text-black line-clamp-2">{localText}</p>
          <p className="text-gray-500 line-clamp-2">{translation}</p>
        </div>

        <button
          onClick={() => onVideoChange(!IsVideoSelected)}
          className={`mt-3 text-sm px-3 py-1 rounded transition ${
            IsVideoSelected ? "bg-gray-400 text-white" : "bg-brand text-white"
          }`}
        >
          {IsVideoSelected ? "Hide Details" : "View Details"}
        </button>
      </article>

      {IsVideoSelected && (
        <aside className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg p-6 z-50 overflow-y-auto">
          <button
            onClick={() => onVideoChange(false)}
            className="text-sm font-semibold text-black  hover:text-gray-700 mb-4"
          >
            Close
          </button>
          <h2 className="text-xl font-semibold mb-2">Video Details</h2>
          <div className="aspect-video w-full rounded mb-4">
            <video controls className="w-full h-full object-contain rounded">
              <source src={video_url} type="video/mp4" />
            </video>
          </div>

          <p className="mb-2">
            <span className="font-medium">Code:</span> {videoCode}
          </p>
          <p className="mb-2">
            <span className="font-medium">Local Text:</span> {localText}
          </p>
          <p className="mb-4">
            <span className="font-medium">Translation:</span> {translation}
          </p>
          <button
            className="px-4 py-2 bg-brand text-white rounded"
            onClick={() => handlOpenEditingModal(true)}
          >
            Edit Video
          </button>
        </aside>
      )}

      {isOpen && (
        <MediaAssetMetaUpdate
          assetToUpdate={{
            localText,
            translation,
            id,
          }}
          assetTypeToUpdate="Video"
          setIsModalOpen={(val) => handlOpenEditingModal(val)}
        />
      )}
    </>
  );
}

export default VideoCardComponent;
